import React from "react";

const SeverityError = ({ width = "17", height = "16" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.825 11.5195L10.2434 1.70196C9.78474 0.940952 8.9919 0.480469 8.1403 0.480469C7.28869 0.480469 6.49585 0.940952 6.03718 1.70196L0.455563 11.5195C0.0542584 12.2289 0.0403876 13.1116 0.419177 13.8349C0.857246 14.6493 1.67466 15.1506 2.55868 15.147H13.7219C14.5999 15.1569 15.4159 14.6683 15.8614 13.8658C16.2515 13.1346 16.2376 12.2366 15.825 11.5195ZM8.1403 12.0597C7.73839 12.0597 7.41258 11.7142 7.41258 11.2879C7.41258 10.8616 7.73839 10.5161 8.1403 10.5161C8.54221 10.5161 8.86802 10.8616 8.86802 11.2879C8.86802 11.7142 8.54221 12.0597 8.1403 12.0597ZM8.1403 9.74428C8.54221 9.74428 8.86802 9.39873 8.86802 8.97246V5.8852C8.86802 5.45894 8.54221 5.11339 8.1403 5.11339C7.73839 5.11339 7.41258 5.45894 7.41258 5.8852V8.97246C7.41258 9.39873 7.73839 9.74428 8.1403 9.74428Z"
      fill="#F00707"
    />
  </svg>
);

export default SeverityError;
